import { cn } from '../../../lib/utils.ts';
import type { MenuItem, MenuSubItem, NavPathOverrideEnum } from '../contracts.ts';

export const ITEM_ICON_CLASSNAME = 'h-4 w-4 shrink-0';

export function createIsSelected(pathOverride: NavPathOverrideEnum, pathname: string) {
    return (item: MenuItem | MenuSubItem) => {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- This is legacy code, if you know what are you doing, please fix me
        if (pathOverride) {
            return pathOverride === item.id;
        }
        return item.href === pathname;
    };
}

export function createIsSelectedOnlyTopLevel(
    pathOverride: NavPathOverrideEnum,
    isSelected: (item: MenuItem | MenuSubItem) => boolean,
) {
    return (item: MenuItem) => {
        if (!item.subItems) {
            return isSelected(item);
        }

        if (item.id === pathOverride) {
            return true;
        }

        const subItemIds = item.subItems.map((subItem) => subItem.id);
        if (subItemIds.includes(pathOverride)) {
            return true;
        }

        return false;
    };
}

export function createGetItemClassname(
    pathname: string,
    isSelected: (item: MenuItem | MenuSubItem) => boolean,
) {
    return (item: MenuItem | MenuSubItem) => {
        return cn(
            'cursor-pointer',
            {
                'pointer-events-none': item.href === pathname,
            },
            isSelected(item) ? 'bg-blue-50 text-blue-600' : 'text-neutral-950 hover:bg-neutral-100',
            'rounded-md group flex w-full items-center gap-2 px-3 h-8',
        );
    };
}

export function createGetTopLevelItemClassname(
    pathname: string,
    isSelectedOnlyTopLevel: (item: MenuItem) => boolean,
) {
    return (item: MenuItem) => {
        return cn(
            'cursor-pointer',
            {
                'pointer-events-none': item.href === pathname,
            },
            isSelectedOnlyTopLevel(item)
                ? 'bg-blue-50 text-blue-600'
                : 'text-neutral-950 hover:bg-neutral-100',
            'rounded-md group flex w-full items-center gap-2 px-3 h-8',
        );
    };
}

export function createGetSubItemClassname(
    pathname: string,
    isSelected: (item: MenuItem | MenuSubItem) => boolean,
) {
    return (subItem: MenuSubItem) => {
        return cn(
            subItem.href === pathname && 'pointer-events-none',
            isSelected(subItem) ? 'bg-blue-50 text-blue-600' : 'text-neutral-950',
        );
    };
}
